module.exports = __webpack_public_path__ + "static/media/evopng.3ce12079.png";